"use client";

import { BuilderContent } from "@builder.io/sdk";
import { createContext, useContext } from "react";

export interface Story extends BuilderContent {
  id: string;
  name: string;
  firstPublished: number;
  lastUpdated: number;
  data: {
    slug: string;
    previewImage: string;
    genres: string[];
    description?: string;
    title?: string;
  };
}

export const StoryContext = createContext<Story | null | undefined>(undefined);

export function useStoryContext() {
  const ctx = useContext(StoryContext);
  if (ctx === undefined) {
    throw new Error("useStoryContext must be used within a <StoryContextProvider/>");
  }

  return ctx;
}
